function resetStyles (styleObj) {
  let resetStyle = ''
  const reg = /([a-z]*)([A-Z]+)([a-z]*)/g
  for (const key in styleObj) {
    resetStyle += `${key.replace(reg, replacer)}:${styleObj[key]};`
  }
  return resetStyle
}

function replacer (match, p1, p2, p3, offset, string) {
  return p1 + '-' + p2.toLowerCase() + p3
}

function callBack (el, { value }) {
  let leftText = ''
  let rightText = {}
  const {
    text,
    textConfig: { textLines, oneLineText },
    clickText: { open, close },
    clickStyle,
    leftLabel,
    leftStyle
  } = value
  if (leftLabel) {
    leftText = `<span style="${resetStyles(leftStyle)}">${leftLabel}</span>`
  }
  rightText = {
    open: `<span style="${resetStyles(clickStyle)}">${open}</span>`,
    close: `<span style="${resetStyles(clickStyle)}">${close}</span>`
  }
  switch (textLines) {
    case 'Infinity':
      el.innerHTML = leftText + text + rightText.close
      break
    default:
      el.innerHTML = leftText + text.substring(0, oneLineText * textLines) + '...' + rightText.open
      break
  }
}

export default {
  inserted: callBack,
  update: callBack
}
